import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Calendar, Play } from 'lucide-react';

interface DateRangeSelectorProps {
  dateRange: string;
  startDate: string;
  endDate: string;
  selectedMonth: string;
  onDateRangeChange: (value: string) => void;
  onStartDateChange: (value: string) => void;
  onEndDateChange: (value: string) => void;
  onSelectedMonthChange: (value: string) => void;
  onGenerateReport: () => void;
  isGenerateDisabled: boolean;
}

const DateRangeSelector: React.FC<DateRangeSelectorProps> = ({
  dateRange,
  startDate,
  endDate,
  selectedMonth,
  onDateRangeChange,
  onStartDateChange,
  onEndDateChange,
  onSelectedMonthChange,
  onGenerateReport,
  isGenerateDisabled
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Calendar className="h-5 w-5" />
          Generate New Report
        </CardTitle>
        <CardDescription>
          Select a date range or month for your report
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1">
              <label className="text-sm font-medium mb-2 block">Report Period</label>
              <Select value={dateRange} onValueChange={onDateRangeChange}>
                <SelectTrigger>
                  <SelectValue placeholder="Select period" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="custom">Custom Date Range</SelectItem>
                  <SelectItem value="month">Specific Month</SelectItem>
                  <SelectItem value="last7days">Last 7 Days</SelectItem>
                  <SelectItem value="last30days">Last 30 Days</SelectItem>
                  <SelectItem value="last3months">Last 3 Months</SelectItem>
                  <SelectItem value="last6months">Last 6 Months</SelectItem>
                  <SelectItem value="lastyear">Last Year</SelectItem>
                </SelectContent>
              </Select>
            </div>
            
            {dateRange === 'custom' && (
              <>
                <div className="flex-1">
                  <label className="text-sm font-medium mb-2 block">Start Date</label>
                  <Input
                    type="date"
                    value={startDate}
                    onChange={(e) => onStartDateChange(e.target.value)}
                  />
                </div>
                <div className="flex-1">
                  <label className="text-sm font-medium mb-2 block">End Date</label>
                  <Input
                    type="date"
                    value={endDate}
                    onChange={(e) => onEndDateChange(e.target.value)}
                  />
                </div>
              </>
            )}
            
            {dateRange === 'month' && (
              <div className="flex-1">
                <label className="text-sm font-medium mb-2 block">Select Month</label>
                <Input
                  type="month"
                  value={selectedMonth}
                  onChange={(e) => onSelectedMonthChange(e.target.value)}
                />
              </div>
            )}
          </div>
          
          <div className="flex justify-end">
            <Button 
              onClick={onGenerateReport} 
              disabled={isGenerateDisabled}
            >
              <Play className="mr-2 h-4 w-4" />
              Generate Report
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default DateRangeSelector;
